'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var PropTypes = require('prop-types');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CatCardIcon = function CatCardIcon(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Cat-Card' : _ref$title,
    props = _objectWithoutProperties__default.default(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsxs("svg", _objectSpread(_objectSpread({
    role: "img",
    width: "25px",
    height: "15px",
    viewBox: "0 0 75 47",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    title: title
  }, props), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsx("title", {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("defs", {
      children: /*#__PURE__*/jsxRuntime.jsx("polygon", {
        id: "path-1",
        points: "0 0.379577778 9.60678947 0.379577778 9.60678947 18.9958833 0 18.9958833"
      })
    }), /*#__PURE__*/jsxRuntime.jsx("g", {
      id: "Cat-Card",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/jsxRuntime.jsxs("g", {
        children: [/*#__PURE__*/jsxRuntime.jsx("rect", {
          id: "Rectangle",
          fill: "#000000",
          x: "0",
          y: "0",
          width: "75",
          height: "47",
          rx: "5"
        }), /*#__PURE__*/jsxRuntime.jsx("rect", {
          id: "Rectangle-Copy-3",
          fill: "#000000",
          x: "8",
          y: "0",
          width: "60",
          height: "47",
          rx: "5"
        }), /*#__PURE__*/jsxRuntime.jsx("rect", {
          id: "HR",
          fill: "#FFCD11",
          x: "48",
          y: "22",
          width: "20",
          height: "3"
        }), /*#__PURE__*/jsxRuntime.jsxs("g", {
          id: "Cat-Logo",
          transform: "translate(8.000000, 14.000000)",
          children: [/*#__PURE__*/jsxRuntime.jsxs("g", {
            id: "Group-3",
            children: [/*#__PURE__*/jsxRuntime.jsx("mask", {
              id: "mask-2",
              fill: "white",
              children: /*#__PURE__*/jsxRuntime.jsx("use", {
                xlinkHref: "#path-1"
              })
            }), /*#__PURE__*/jsxRuntime.jsx("g", {
              id: "Clip-2"
            }), /*#__PURE__*/jsxRuntime.jsx("path", {
              d: "M8.78573684,15.9268556 C9.48678947,15.3410222 9.60678947,14.6148 9.60678947,13.96405 L9.60678947,11.2296333 L5.79836842,11.2296333 L5.79836842,14.9409667 C5.79836842,15.4713833 5.36889474,15.9009944 4.83994737,15.9009944 C4.31152632,15.9009944 3.91836842,15.4713833 3.91836842,14.9409667 L3.91836842,4.42552222 C3.91836842,3.89457778 4.31152632,3.46496667 4.83994737,3.46496667 C5.36889474,3.46496667 5.79836842,3.89457778 5.79836842,4.42552222 L5.79836842,8.15955 L9.60205263,8.15955 L9.60205263,4.28618889 C9.60205263,2.14552222 8.20678947,0.383272222 4.80836842,0.379577778 C1.31889474,0.379577778 -5.26315789e-05,2.14974444 -5.26315789e-05,4.28988333 L-5.26315789e-05,15.2676611 C-5.26315789e-05,17.3903833 1.67942105,18.9958833 3.82836842,18.9958833 L5.00784211,18.9958833 L8.78573684,15.9268556 Z",
              id: "Fill-1",
              fill: "#FFFFFF",
              mask: "url(#mask-2)"
            })]
          }), /*#__PURE__*/jsxRuntime.jsx("polygon", {
            id: "Fill-4",
            fill: "#FFFFFF",
            points: "24.4857807 16.4171104 24.4857807 4.50862468 22 4.50862468 22 1 31 1 31 4.50862468 28.5002766 4.50862468 28.5002766 19 27.4346575 19"
          }), /*#__PURE__*/jsxRuntime.jsx("polygon", {
            id: "Fill-6",
            fill: "#FFCD11",
            points: "26 20 16.6693825 12 7 20"
          }), /*#__PURE__*/jsxRuntime.jsx("polygon", {
            id: "Fill-8",
            fill: "#FFFFFF",
            points: "15.8276047 9.18630926 16.8748657 4.03788214 17.9156821 9.18630926 15.8276047 9.18630926 16.8748657 10.0598878 23 15 19.5708915 1 14.1552095 1 11 14.6231724 16.8748657 10.0598878"
          }), /*#__PURE__*/jsxRuntime.jsx("path", {
            d: "M32.9839796,1.88042721 C33.157186,1.87531925 33.1966566,1.80334339 33.1966566,1.71279313 C33.1966566,1.62502902 33.157186,1.57998607 33.0104481,1.57998607 L32.7898769,1.57998607 L32.7898769,1.88042721 L32.9839796,1.88042721 Z M32.7898769,2.06384955 L32.7898769,2.57185976 L32.606919,2.57185976 L32.606919,1.39656373 L32.9867657,1.39656373 C33.2022289,1.39656373 33.4255863,1.45460878 33.4255863,1.72068725 C33.4255863,1.85628047 33.3429301,1.96261899 33.1859763,1.99465986 L33.1859763,2.00023218 C33.3485024,2.03180868 33.3670769,2.10378454 33.3856513,2.23148363 C33.4014395,2.34339447 33.414906,2.46552124 33.454841,2.57185976 L33.2208033,2.57185976 C33.2073369,2.50545623 33.1887625,2.43115858 33.1808684,2.36196889 C33.1678663,2.26073833 33.1678663,2.16786626 33.1144648,2.11214302 C33.0689575,2.06384955 33.0081263,2.06942187 32.9440446,2.06384955 L32.7898769,2.06384955 Z M33.8244718,1.99744602 C33.8244718,1.54515904 33.4576271,1.17552821 33.0030183,1.17552821 C32.545159,1.17552821 32.1755282,1.54515904 32.1755282,1.99744602 C32.1755282,2.45484096 32.545159,2.82447179 33.0030183,2.82447179 C33.4576271,2.82447179 33.8244718,2.45484096 33.8244718,1.99744602 L33.8244718,1.99744602 Z M32,1.99744602 C32,1.44717901 32.4467147,1 33.0030183,1 C33.5556072,1 34,1.44717901 34,1.99744602 C34,2.55328535 33.5556072,3 33.0030183,3 C32.4467147,3 32,2.55328535 32,1.99744602 L32,1.99744602 Z",
            id: "Fill-10",
            fill: "#FFFFFF"
          })]
        })]
      })
    })]
  }));
};
CatCardIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CatCardIcon",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Cat-Card'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var CatCardIcon$1 = CatCardIcon;
CatCardIcon.propTypes = {
  title: PropTypes__default.default.string
};

exports.default = CatCardIcon$1;
//# sourceMappingURL=CatCardIcon.js.map
